import { render, staticRenderFns } from "./ScreenShare.vue?vue&type=template&id=4654e8d3&scoped=true&"
import script from "./ScreenShare.vue?vue&type=script&lang=js&"
export * from "./ScreenShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4654e8d3",
  null
  
)

export default component.exports